import { initAjaxLoadMore } from './ajax-load-more';

export function initEducationProgramsLoadMore(root?: ParentNode): void {
  const scope = root ?? document;

  initAjaxLoadMore(scope, {
    gridSelector: '[data-education-programs-grid]',
    wrapSelector: '[data-education-programs-load-more-wrap]',
    btnSelector: '[data-education-programs-load-more]',
    cardSelector: '[data-education-program-card]',
    modalsContainerSelector: '[data-education-program-modals]',
    initFlag: 'educationProgramsLoadMoreBound',
  });
}
